module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "normal3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_c('br', {
    staticClass: "calibre4"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "normal3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "normal7"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Are you going to eat that or just stare at it?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("For the moment, at least, Rick was merely going to stare at the plate in front of him. It wasn’t exactly a plate, but a red plastic basket, lined with checkered paper and containing a green chile cheeseburger and fries. His sister was already two bites into her lunch, a large chef’s salad with Thousand Island dressing. She stabbed at a slice of tomato with her fork and waited for her brother to answer. She was in no hurry. They sat in a booth on plastic seats, a small jukebox on the wall between them. Outside, it was a perfect day, typical for New Mexico, which would still be the Sunshine State had Florida not stolen the name. But Land of Enchantment worked just as well. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Anna, this may be the last green chile cheeseburger I’ll eat for years. It never occurred to me that they won’t have green chile cheeseburgers in Rome.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“That city is a culinary backwater, Rick. You’ll probably waste away to nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("He picked up his glass and held it out, studying the brown liquid. “And Alien Ale. They won’t have it, either.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“You’ll have to drink water. But you’ve always been ingenious; you’ll find a way to survive.” She opened a packet of Saltines. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“You’re right, I’ll muddle through somehow. But will I be able to make it without my dear sister constantly…?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Giving you excellent advice?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Nagging")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" was the word that came to mind.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Mom and Dad are in Brazil, someone had to do it.” She poked at the salad. “You’re not really nervous about making this move, are you, Rick?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("He finally bit into his cheeseburger, and she waited for him to swallow. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Boy, that’s good,” said Rick. “The best this side of San Antonio.” He took a sip of beer. “Why should I be nervous? I’ve sold all my belongings and taken my savings out of the bank so I can move to another country with the tenuous hope of restarting a business which, I might add, was doing quite well here in Albuquerque.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“We’ve been through this, Rick. You know a lot of people there, and Uncle Piero will help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("He took another drink of beer, this one longer. “Piero will probably start on his thing about me becoming a cop.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“I thought that was just a joke.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“I’m not so sure, Anna. The e-mails I’ve been getting from him keep mentioning cases he’s working on that I might find interesting.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“He has nobody to talk to about his work except the other cops. You’ll fill the void.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Rick shrugged and picked up a French fry in his fingers. “This may be the last time for a while that I can eat one of these with my fingers. It’s considered quite the ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("bruta figura")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" not to use a fork in Italy, as you’ll remember.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Anna rolled her eyes. “Enough already with the food stuff. What about the real issue of importance, dear brother?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“And what would that be?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“When are you going to find a nice girl and settle down?” She said it with a slight Italian accent. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Your Mamma imitation is creepy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Years of practice. You are past thirty. I already had two children at your age.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“And great kids they are. You took a lot of heat off me with Mamma by getting married and having those two. Don’t think I don’t appreciate it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("She sipped her iced tea. “The pressure will start building up again, Rick. Mamma was only temporarily distracted. She wants the best for her bambino as well as her daughter. Have you been in touch with your classmates from the American School?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Art Verardo. He knows I’m coming. That’s about it. I’ll find out about others when I get there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Including the girls. What about ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("la bella")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" Lidia? You two were quite a number back in the day.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Art hasn’t mentioned her in his e-mails.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal9"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("He chewed his last bite of burger and thought about Lidia. If she is still in Rome and is single, it might be worth giving up green chile cheeseburgers for a while. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('img', {
    staticClass: "calibre6",
    attrs: {
      "alt": "Image",
      "src": "OEBPS/Images/Break.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal7"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("In the backseat of the bus, two tourists from Texas craned their necks to see what the tour guide was talking about over the loudspeaker. The woman seated nearest the window held her camera at the ready, while her husband peered over her shoulder. Along with the rest of the tour group, the two had just gotten back on after a rushed loop around the inside of the Colosseum, where she’d spent most of the time taking pictures of the feral cats basking on the stones. The bus made a wide turn around the street that circled the arena and now headed down the six-lane Via dei Fori Imperiali, named for the ruins that flanked it. Every Roman emperor worth his salt had built a forum, and those that weren’t visible along this street were buried under it. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“We know that the violin had not been invented until well after Nero’s time,” said the voice over the loudspeaker. It belonged to a man wearing a wrinkled white shirt with a name tag slightly askew. A thin tie hung loosely from an open collar. His eyes were hidden behind dark aviator Ray-Bans. “In fact, historians now agree that while Rome burned, the emperor was playing a zither.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“You know, Wade,” said the woman from Texas, “I’m beginning to wonder about this tour guide.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Why, Glenda?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“What he said about soccer games in the Colosseum.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Why not? These Italians love soccer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Okay, but saying that Jerry Jones came over here and studied the Colosseum before building Cowboy stadium? I don’t remember reading about that back in Dallas.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The loudspeaker crackled to life again. “Julius Caesar himself marched down this street with his legions. It was after one of those parades that he went back to his villa and invented what we now know as the Caesar salad.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“See what I mean?” Glenda poked her husband in the ribs.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Maybe you’re right. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“But what he said about the Baths of Caracalla having the largest bathtub ring in recorded history, that made sense to me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The bus moved down the street as the guide continued his running commentary. When it reached the huge monument to Italy’s first king, it swung to the left and climbed past the steps leading up to city hall. Passing more ruins, it came to the river.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“For many years,” said the voice on the loudspeaker, “a troll lived under this bridge, demanding payment to let people cross. The authorities eventually put a stop to it, and last I heard he was working a bridge over the Arno, in a rural area east of Florence. His name is Otto.” The woman from Texas dutifully took a photograph of the bridge as they crossed on the way to the Vatican. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("When the bus approached St. Peters Basilica, the guide’s commentary turned to the papacy. “It is from that tiny chimney that the cardinals signal whether they have come to a decision on a new pope. White smoke indicates that they have elected one, black smoke means they left the pizza in the oven too long. Of course, in the Middle Ages, the pontiff was selected by an arm-wrestling competition among the cardinals.” Phones and a few real cameras clicked away as the bus stopped at the edge of the square before swinging a looping U-turn and going back toward the river.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("An hour later, as the tour was coming to its conclusion, the couple in the backseat had decided that the tour wasn’t so bad after all, despite what the guide had said about Jerry Jones. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“We sure are learning a lot about ancient history, Glenda. I always thought that Cleopatra ended her days in Egypt, but apparently she fell on her asp while riding on a sedan chair right here in Rome.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" “And it was just after watching the elephant races at the Circus Maximus,” she said to her husband. “Don’t forget that part.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“That shows you how Hollywood doesn’t care about historical accuracy. The chariot scene in Ben Hur was just plain made up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The tour ended on a street near the Spanish Steps. The guide, the young man with dark sunglasses, thanked each of the passengers as they stepped off the bus. Most of them said nothing to the guide, or if they did, the comment was less than positive. Glenda and Wade told him how informative the tour was, tipped the man five euros, and started toward Piazza di Spagna. As they neared the bottom of the Spanish Steps, the crowds thickened. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Look at all these people, Wade. It’s like Kyle Field on a fall Saturday. Maybe we should just go back to the hotel. We could get pickpocketed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal9"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Not on your life. I want to see the Spanish Steps, where he said that international Slinky competition takes place. What a shame that we missed it by two weeks. We could have cheered on the American team.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('img', {
    staticClass: "calibre6",
    attrs: {
      "alt": "Image",
      "src": "OEBPS/Images/Break.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal7"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("They ordered steak, as would be expected in Buenos Aires. No meal in Argentina was complete without a slab of meat from a cow raised on the sweet grass of the Pampas, and certainly not a business lunch. The choice wasn’t just a matter of national pride, it was a taste cultivated over generations of Argentines who considered themselves gauchos, even if they’d only seen horses in movies. There were sharp knives set at each place on the crisp white tablecloth, but the steak would be so tender it could be cut with a spoon. The knives proved useful to slice off bites of yellow ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("provoleta")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" cheese, grilled to perfection and served as an appetizer, another standard in Argentine restaurants. This one was among the more elegant eateries in the city, and an appropriate setting to consummate an important business deal. The other diners, mostly men in tailored suits, talked in low voices as they sliced their steak and discussed the usual topics: politics and making money. The two were often connected. At this table the talk was strictly business. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Juan Alberto Sanguinetti sipped his wine, a red from Mendoza trying hard to be robust, and he was surprised to find that it wasn’t bad. Though it was not one of the more famous labels of that region, his host made a point of ordering it. Of course he was the marketing manager for the winery that produced it. Juan Alberto wondered if the man had checked to be sure it was on the restaurant’s wine list before reserving their table. He wouldn’t ask. Instead, he listened patiently while his host extolled the climate of the valley where the grapes had come to maturity, although Juan’s mind began to wander when soil acidity took over from climate. He understood that he should know about such things if he was going to sell their wine in Italy, but as he had done throughout his thirty or so years, he assumed he would rely on his wits and personality to get the job done. How hard could it be to sell Argentine wine? He’d been drinking it himself since he was a toddler, when his grandmother let him sip from her glass, so he should be able to extol its qualities. Only during his short sojourn in America was it difficult to find wines from home, and he was forced to drink wine from California and even—he shuddered at the memory—New Mexico.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The host was now describing the angles of the sun’s rays at various times of the year, and what it meant for the maturation of the grape. Juan Alberto fought off a yawn. He’d been up late the previous night, woke up mid-morning with no appetite for breakfast, and now the wine was hitting his empty stomach. He took a sip from his water glass, wishing he could splash some of it in his face to liven himself up. His cell phone saved him. He pulled it out and checked the number. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“I really must take this, if you don’t mind. One of my contacts in Rome.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The man grinned and waved him away with his hand. “Of course, of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Juan Alberto got to his feet and walked quickly toward the ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("caballeros")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" door at the opposite side of the dining room, just missing a man coming out while straightening his tie. He put the phone to his ear as he entered the bathroom.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Hola")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(", Mina. You called at the perfect time.” He walked to the sink and checked himself out in the mirror before pushing back a few strands of his thick black hair, the only ones out of place.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“You didn’t say goodbye this morning, Juancito.” He didn’t need to see her face to know it held the signature pout. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“You were still asleep, ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("mijita")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(", I could not bear to wake you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("She sniffed. “I am going to miss you so.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Don’t start, Mina. You know it will only be for a few weeks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Enough time to meet some Italian ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("desvergonzada")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(".” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("He hoped it would take only a few days to meet one. “I have to go, my new boss is waiting. See you tonight.” He hung up, slipped the phone into his pocket, and turned on the cold water tap. Carefully, so as not to get any drops on his shirt or tie, he rubbed the cool water into his face before taking one of the cloth towels from the basket and patting himself dry. Good enough to keep awake through coffee. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("He arrived back at the table at the same time as their steaks, each one barely fitting on the expanse of its plate and oozing red juices. The aroma of the ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("parilla")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" wafted up from the dark grill marks seared into the crusted surface of the meat. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“What is it the Italians say for ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("buen provecho")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Bon appetite")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(",” answered Juan Alberto, earning a puzzled look from his host. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal9"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("He would make a point of learning the correct Italian phrase early on. Rick would know.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('img', {
    staticClass: "calibre6",
    attrs: {
      "alt": "Image",
      "src": "OEBPS/Images/Break.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal7"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("O’Shea’s Irish Pub sat at ground level on a narrow street, a few blocks from the Tiber, in a part of town considered old even by local standards. The street had been laid out originally by the Romans, but Romans who wore togas and sandals rather than Armani suits and Bruno Magli shoes. Now the area had a distinctly medieval feel to it. Even the dirt—which municipal street-sweepers regularly and lovingly moved from one side of the pavement to the other—dated to the fifteenth century. The low buildings at the edge of the cobblestones were just as old. Developers would love to tear them down to put in something more modern, but eliminating anything old in this city almost required an act of Parliament. New buildings in this part of Rome were as scarce as Tex-Mex restaurants. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("It was a typical weekday evening at O’Shea’s, and Guido O’Shea stood behind the bar surveying the sparse crowd. His outfit was the same every night: black pants, a white shirt, and a white apron blemished by a few beer spots. He was clean shaven, and his hair carefully combed. The very picture of a professional tavern owner, he thought. As he looked out over the room, he wondered, as he always did when the place wasn’t full, what could be done to bring in a better clientele. By better, he meant larger, since his goal was selling more beer, and it didn’t matter who bought it as long as they paid and didn’t trash the place after doing so. O’Shea’s was already a regular watering hole among some circles of younger English-speaking expats. He served up warm beer to the Brits and Irish and, thanks to an ear for languages, he could affect an appropriate British Isles accent when required. For his fellow Americans the brews were always served cold, and for those who truly wanted to feel at home, in the bottle. To go along with the alcohol he had a cook in the back—chef would be too generous a term—making snacks, mostly fried, which the regulars described in less than glowing terms, though not so Guido could hear. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("TV monitors hung at various strategic positions around the room, their modernity contrasting with a décor that could be described as mid-century modern, that century being the seventeenth. Wood was the dominant feature of the place: wood floors, wood tables and benches, a long wood bar, and dark wood beams crossing the low ceiling. Long John Silver could have clomped in, ordered a tankard of ale, and felt at home. The TVs were the big draw, and Guido knew it. His best nights were those when some sporting event was featured on the flat screens. Beer and football went together, as well as beer and soccer, and certainly beer and Australian-rules football. The satellite charges were outrageous but worth it to bring in thirsty customers looking for a piece of the homeland.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Tonight the best he could muster was a rerun of the NBA semi-finals from the previous season, and the numbers at the tables showed it. Two women sitting in one corner of the room were not paying any attention to the game on the screen above them. One, dressed in a smart business suit, looked like she had come directly from the office. She nursed a glass of Peroni, taking an occasional stale peanut from a small bowl Guido had put between them, and dropping the shells on the floor. The other wore jeans and a sweater, and sipped from a bottle of Miller Lite. The two had been friends since they were students at the American Overseas School of Rome. One had an Italian father and British mother, the other an Italian mother and American father. Both had left Italy to go to the university, one in England and the other in the States, and both had returned. They were part of a core of AOSR alums who gathered on occasion at Guido’s to talk about the good old days in high school, but tonight the mood at their table was somber. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“I’m at my wit’s end,” said Giulia, who ran a tour bus company. “I had to fire one of my guides and I can’t find anyone to replace him. If I don’t get someone soon, I’ll have to cut back on my tours. I can’t afford to do that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The other woman sipped from her bottle and put it down. “Why did you can him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“He drank too much and when he picked up the microphone at the front of the bus he’d start spouting all sort of stuff. A few of the clients liked it, but those who knew anything about Rome got annoyed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Really? What kind of stuff?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The first woman shook her head in disgust. “The last straw was when he was at the Vatican and told the group that it was called a basilica because the pope grew basil in planters hanging from the side windows.” She took another pull from her beer. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“That’s pretty clever.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“But not what people want to hear on what they think is a serious bus tour of the city.” She drained her glass and signaled Guido for a refill. “They want a commentary that brings the ruins to life. But with facts.” Giulia glanced up at the screen where two players were arguing with a ref, then back at her companion and frowned. “I don’t see what’s so funny, ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("cara")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Sorry. I was just thinking. There just may be someone who could step in temporarily.” She shook her head. “Though he’ll probably be too busy.” She shrugged. “But you never know. I think he gets into Rome in a few days.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“I’d take almost anyone. Don’t keep me in suspense. Someone I might know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“You may remember him. He was in our class.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Aha. I wondered when all your computer searches of our classmates would come in handy. It isn’t that nerdy Timothy Testa, is it? He was always trying to get me to go out with him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“No, Timothy is working at a bank in London.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Jason Failla? He always aced the history tests. He could work.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Nope. Jason’s Facebook page puts him in Miami, selling insurance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The new Peroni arrived and she took a long pull. “Don’t keep me in suspense.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Let’s see, what’s his name again?” A pause. “Oh yeah, Rick Montoya.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The beer spilled when the other woman banged the table. Peanuts fell to the floor. People at the nearest table looked over in surprise. It even got Guido’s attention.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Get out! Rick? You’ve got to be kidding.” She grabbed a tiny napkin and tried to soak up the beer before it dripped in her lap. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Not kidding. I heard it from a good source. He’s moving to Rome to start his own business, translating and interpreting.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“He never gave me the time of day. He was always with Lidia.” She shook her head. “Isn’t that ironic?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("They both thought about Lidia, the best-looking girl in the class.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal9"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Did I mention that Rick is still single?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('img', {
    staticClass: "calibre6",
    attrs: {
      "alt": "Image",
      "src": "OEBPS/Images/Break.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal7"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Your police have done nothing to find my husband’s murderer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Commissario Piero Fontana tapped a finger on the armrest of the sumptuous chair as he looked directly at the woman sitting across from him, trying his best to avoid saying something rude. She was, after all, the Countess Zimbardi, the last of a long line of Roman nobility, and such things still counted for something in Italy, especially in Rome. When said nobility was combined with wealth, it counted for quite a lot. As such, the countess was able to pick up the telephone in her ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("palazzo")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" and call a high-level official in the Interior Ministry, who happened to have been a friend of her late husband the count. The result was the visit by Commissario Fontana, who normally would not be involved in a case which the police dismissed as a simple mugging gone bad and consigned to the file of homicides likely not to be solved. The file was not so-named officially, but everyone in the division knew that’s what it contained. Not that they hadn’t tried to find the murderer when the body had been found. Thanks to the count’s notoriety—at least in some social circles—the investigation had been extensive. Despite serious efforts, the police came up with no suspects. They assumed the killing was perpetrated by one of the petty criminals who occasionally prowled the city streets. Violent crime was rare in the city’s historic center, but it did happen on occasion. Unfortunately for Commissario Fontana, the victim was a count, though it could well be said that it was even more unfortunate for Count Zimbardi himself. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("commissario")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" kept the same serious look on his face. “I can understand your frustration, Countess. It is matched by our own. Be assured that we are doing everything possible to find the guilty party, but the randomness of the crime makes our investigation very difficult.” It wasn’t exactly true, but he hoped it was enough to hold her off while they made another attempt to track down the killer. He disliked rounding up suspects purely for the sake of demonstrating that something was being done, but it might be needed to placate the woman. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("She looked back without speaking, giving the policeman the sense that she was weighing her thoughts before responding. He hoped it would not be another disparagement of the police, but the hope was weak. He waited, and her eyes moved around the room. A sumptuous room it was, as would be expected for an apartment at this address. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The Teatro di Marcello started its life two millennia earlier when the Emperor Augustus decided to take over a project started by Julius Caesar, and dedicate it to his late nephew Marco Claudio Marcello. The theater, with its classical half-circle design, had held fifteen thousand spectators, but over the centuries it suffered the fate of so many monuments in the city. Its stone was recycled to construction sites around Rome, became a fortress for powerful families, and fell into various states of disrepair. But real estate values being what they have always been in downtown Rome, it was eventually renovated and became a location which many ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("per bene")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" Romans would kill to call home. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“I have discovered something that could help with the investigation.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("It was not what the ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("commissario")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" had expected, but he was pleased to hear her words. He leaned forward. “And what would that be, Countess?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“My husband was a traditionalist. Perhaps old-fashioned would be a more accurate way to describe the count. He kept a journal and he wrote letters. In long hand. In going through the papers in his study I came across them in a file. They were not locked up, mind you. Umberto had nothing to hide from me.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The policeman considered the last comment. How could she be so certain that her husband had nothing to hide? He spent a mere ten minutes with the woman and it seemed like an hour. Did the count seek out other companionship? He put the thought out of his mind and returned to what she had said. “We would be interested in the material, Countess. It might be helpful, even though it appears random violence took your husband from you. Have you found anything of interest to the case in these papers?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“I haven’t read them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“I don’t understand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("She spoke slowly, as if talking to a child, or someone who should understand without her telling him. “Commissario, my husband’s mother was British, he had a British nanny, and he spent much of his youth, including schooling, in Britain. English was effectively his first language. So his journal is written in English, as were the letters from his British schoolmates.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“And you don’t read English.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Her reply was an annoyed frown. “I don’t suppose you have anyone on your staff who could do the work? This is not the sports pages of the tabloids, unfortunately. Whenever I see a policeman sitting in his squad car he seems to be either reading the sports pages or a comic book.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Fontana let the comment pass, and an idea jumped into his head. “We have an American who we sometimes contract for translations. He does not come cheap, so if you can pay him directly, it would avoid my having to justify the expense in the bureaucracy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("She waved a hand, as if shooing away a flying insect. “Of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The policeman took her answer as a welcome end to the conversation. He got to his feet. “I will have him contact you in the next few days.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“What’s his name, Commissario?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Montoya. Riccardo Montoya.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal9"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The policeman stole a look at his watch. Too late to get to the airport. Damn this woman. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('img', {
    staticClass: "calibre6",
    attrs: {
      "alt": "Image",
      "src": "OEBPS/Images/Break.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal7"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“The line for Italians is that one, ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Mister")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" Montoya”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The agent pushed the passport back through the opening in the glass with one hand and jerked his thumb with the other. Rick was in the wrong line, but did the guy have to be so rude about it? After all, he was still groggy from the flight, since no amount of airline coffee could make up for being jolted awake by the sudden glare of the cabin lights while bouncing over the Alps. And he had merely stood in the line he always used when arriving in Rome, like all those other times when he was using his American passport. This time, since he was going to be working, it seemed proper to use his Italian one, so could you really blame him for getting in the wrong line? ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("It was an inauspicious arrival. So much for Rick Montoya, suave international traveler. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("He crossed over under puzzled looks from people of many nationalities, especially the Italians of the new line where he took his place. Fortunately, everyone was as tired as he was, and they held their tongues as this column of arrivals, now all Italian, edged forward at the speed of an aging turtle. Several minutes later he realized that he was truly back in Italy when his Italian passport was pushed back by a uniformed agent who paid him no attention whatsoever. And why should he? More important was the conversation about the previous Sunday’s soccer game with his colleague in the booth behind him. Rick had no doubt that the agent would be more attentive to the young lady who was next in line. He noticed her as well—long, dark hair and a slim figure—but was too tired to strike up a conversation. He left the cubicle pulling his carry-on bag, stopping only to glance back at the girl. As expected, the agent was checking her document carefully and carrying on a conversation, no doubt to be absolutely sure she wasn’t a terrorist using a false passport. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Yes, he was back in Rome. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("The various passport control lines merged into a human stream flowing in the direction of the baggage claim area. The Americans moved faster, thinking that after waiting so long in line to get their passports stamped, their bags would already be making turns around the carousels. The Italians, knowing better, took their time, many already talking on their cell phones. Rick stopped and pulled his own from the zippered pocket of his bag. He powered it up and was pleased to see, as promised back in Albuquerque, that it worked. The first message on the screen was a text.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("BENVENUTO NIPOTE. UNABLE TO COME TO AIRPORT. HAD TO MEET WITH A COUNTESS. SENT A DRIVER. KEY WITH DOORMAN. BACI. ZIO PIERO.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Rick assumed the encounter with a countess had something to do with his uncle’s police work, but he couldn’t be sure. Getting to know Piero better was something he looked forward to on this adventure, if that’s what one could call picking up stakes and leaving a decent job in Albuquerque to try his hand at working in Italy. He could do the translation jobs anywhere that had an Internet connection, so why not move back to the city of his youth and get on the interpreting circuit? He kept contact with a classmate of the American School of Rome who’d encouraged Rick to give it a shot. \t")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("His mother, as usual, had mixed feelings—pleased that he would be reconnecting with her native Italy, but worried about his leaving a reliable job and jumping into the unknown. That he would be staying, at least initially, with her brother helped her accept what his father had said was inevitable. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Rick is an adult,” the elder Montoya had said. “He can make his own decisions.” Which was a very American reaction, as would be expected, just as his mother’s ambivalence was ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("molto")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" Italian. Business as usual in the dual-national Montoya family. Since his parents were now in Brazil, they couldn’t complain about being separated from their son, and his sister in Albuquerque encouraged him to take the leap. She would miss him, but with a husband and kids, she had enough family close by to keep her busy.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Rick checked the electronic boards at the end of each carousel, passing flights arriving from Paris, Dakar, Bogota, and London before finding his own. The Paris flight was the only one with a moving belt, but it held only a few bags, and none that remaining passengers wanted to claim. The suitcases moved slowly around the loop, disappeared into the hole in the wall, then reappeared with renewed hope that someone would take pity and give them a home. He got to his aisle, recognizing passengers from his plane. Most stared at the flaps covering the opening of the conveyor, others talked on their cell phones, still others struggled to keep awake. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("He pulled out his own phone again to check e-mails. One was from a friend who regretted missing the goodbye party at an Albuquerque watering hole. Just as well that he was out of town, Rick thought. The guy was a notoriously ugly drunk. Another was an inquiry about translating an article for a scientific journal. That was good, since it meant income, though Rick hated translating scientific jargon. A third asked if he’d arrived safely, and she couldn’t wait to hear how he was adjusting to life in Rome. He was glad to be out of that relationship. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" A loud buzzer and a flashing red light brought him back to the business at hand. The conveyor belt came to life and the people gathered around it began pushing ahead like lemmings nearing a cliff. His bags were among the first to appear, and he elbowed his way to the front, snatching them off under the annoyed looks of fellow travelers. He slung the duffel over his shoulder, pulled out the handles of the carry-on and roller suitcase, and headed for customs. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("He went through the “nothing to declare” line without incident before emerging into the hall where lines of people waited along a railing. Like buyers at a cattle auction, they watched the herds of travelers who plodded their way along the line. Several held signs indicating businesses or travel agencies, some with just a name. Toward the end he spotted someone holding a hand-lettered sign: MONTOYA.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("He hadn’t expected a woman. When Rick owned up that he was Montoya, she shook his hand and introduced herself as Carmella Lamponi. The handshake was firm, as would befit someone who, despite her years, could easily be taken for a professional wrestler. Bleached, close-cropped hair added to the impression. She wore jeans, a Metallica sweatshirt, and red sneakers. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“These all your bags?” Without waiting for an answer she continued. “Not much for someone who’s moving here. The car’s out there.” She pointed to one of the far doors and started walking.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“I’m having other clothes sent.” Rick tried to keep up. “How did you know I was moving here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“The ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("commissario")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" told me.” They reached the door, which opened automatically, and she pointed toward a large, dark blue Alfa Romeo sitting in a space marked with a crossed-out P indicating a no parking zone. “It’s that one.” She pulled a key from her jeans, pressed it, and the trunk popped open. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Have you, uh, worked for my uncle before?” He watched while she heaved his larger suitcase into the trunk with one hand, the duffel with the other. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Put that little one in the backseat,” she ordered, pointing at the carry-on bag, and got into the driver’s seat. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Rick did as he was told and climbed into the passenger position. “I said—”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“I heard you. Have I worked for your uncle? He’s my boss. One of many. I just do this to earn a little extra money when I’m not on duty.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“So you’re a policewoman.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("She glanced at him before pulling into the traffic. “You’re pretty sharp, kid.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("They were still inside the airport compound, passing the Leonardo Da Vinci statue, when Rick asked Carmella how she got into police work. It became immediately apparent that she was not averse to sharing her life story with someone she’d just met, even the nephew of her boss. Even the friendliest of New Mexicans would have waited a few encounters before getting into such details. As they passed slower vehicles, which included every other car on this section of ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("autostrada")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(", she talked. She spoke with the thick ")]), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Romanaccio")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" accent, almost a dialect, that he remembered hearing on the street when he was a kid. He had to concentrate to get it all. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Been working at the Polizia dello Stato for twenty five years. Just made sergeant. Married and divorced. Her former husband, a cop, was a bum. Her son, who just turned twenty and lived with her, was a student at the university. He was lazy and too often took after his father. She was trying to pound some sense into his thick skull. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Rick wondered if she meant it literally. An Italian mamma who was also a cop—definitely a formidable combination. By the time the car pulled onto Piero’s street, she was describing her extended family, but was forced to stop when they reached the door to the building. She got out and opened the trunk. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“When you need a taxi, give me a call.” She handed him a card. “My cop shifts change, so I may be available day or night.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Thanks, Carmella.” He reached into his pocket. “What do I owe you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("“Your uncle got it.” She slid into the car and drove off.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal8"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_vm._v("Rick pulled his hand out of the pocket, realizing it was just as well the fare was covered since he had forgotten to stop at an ATM at the airport to get euros. It was his second rookie error of the day.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3409f730","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Chapter_2.vue
// module id = 81
// module chunks = 0